import React, { useCallback, useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CityDropdownForTrip, CommonInput, CommonModal, CommonTextarea, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import { createZone } from '_services/accountsServices/zoneServices';
import { createVehicleGroup } from '_services/accountsServices/vehicleGroupServices';
import { createVehicleDocType, editVehicleDocType } from '_services/accountsServices/vehicleDocTypeServices';
import { createManufacturer, createStore, editManufacturer, editStore, getPartCategoryList } from '_services/workShopServices/workShopServices';
import AddPartsCategory from 'modals/AddPartsCategory';

const formObj = {
    company_id: StorageService.getCompanyId(),
    name: '',
    category_id: {},
}

const AddEditManufacturerModel = (props) => {

    const { isOpen, closeModal, nextModal, categorySelection = () => { }, getDataCallBack = () => { } } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const [showAddPartsCategory, setShowPartsCategory] = useState(false);

    useEffect(() => {
        if (isOpen?.isDetails) {
            setFormValue((s) => ({
                ...s,
                company_id: isOpen?.company_id,
                name: isOpen?.name,
                category_id: isOpen?.category_id,
            }))
        }

    }, [isOpen?.isDetails])

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditManufacturerSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditManufacturerSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            if (isOpen?._id) {
                let obj = {
                    ...formValue,
                    category_id: formValue?.category_id?.value
                };
                delete obj.company_id;
                const res = await editManufacturer(obj)
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    closeModal(false);
                    props?.ApiCall()
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            } else {
                let obj = {
                    ...formValue,
                    category_id: formValue?.category_id?.value
                }
                const res = await createManufacturer(obj);
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    getDataCallBack(res?.data);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    closeModal(false);
                    categorySelection(res?.data);
                    props?.ApiCall();
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, errorSchema.addEditManufacturerSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction();
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen?._id) {
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
                name: isOpen?.name,
                category_id: { label: isOpen?.category_id?.name, value: isOpen?.category_id?._id },
                id: isOpen?._id,
            }))
        }
    }, [isOpen?._id])

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: loading,
        onSubmit: handleClick,
    }

    const fetchPartCategory = useCallback(async (search, page, limit) => {
        try {
            const response = await getPartCategoryList({
                company_id: StorageService.getCompanyId(),
                offset: page,
                limit,
                search,
                status: 1
            });

            if (response?.responseCode === 200) {
                const vendors = response.data.partData.map(vendor => ({
                    ...vendor,
                    label: vendor.name,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            company_id: StorageService.getCompanyId(),
        }))
    }, [])

    // Add New Category Modal Start //
    const addNewCategoryHandler = () => {
        setShowPartsCategory(true)
    }

    let addPartsCategoryModalProps = {
        isOpen: showAddPartsCategory,
        closeModal: (e) => setShowPartsCategory(false),
        modalMainClass: " _dashCommon_Modal _addExpModal",
        modalTitle: showAddPartsCategory?.isDetails ? 'View Category' : (showAddPartsCategory?._id ? "Update Category" : "Add Category"),
        hideFooterSumbmitBtn: showAddPartsCategory?.isDetails ? true : false,
        hideCompletelyFoolter: showAddPartsCategory?.isDetails ? true : false,
        footerPart: true,
        submitTitle: "Save",
        getDataCallBack: (data) => onhandleSelect({ label: data?.name, value: data?._id }, 'category_id'), // setFormValue((s) => ({ ...s, category_id: {label: data?.name, value: data?._id} }))
    };
    // Add New Category Modal End //

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body mt-2'>
                    <div className='colFlx'>
                        <div className='singleDiv'>
                            <CityDropdownForTrip
                                label="Select Category * "
                                placeholder="Select Category * "
                                fetchData={fetchPartCategory}
                                pageSize={20}
                                disabled={isOpen?.isDetails ? true : false}
                                selectedItem={formValue.category_id ? formValue?.category_id : null}
                                onChange={(data) => onhandleSelect(data, 'category_id')}
                                error={formError['category_id.label']}
                                errorMessage={formError['category_id.label']}
                                isAddButton={true}
                                addButtonAction={(e) => addNewCategoryHandler(e)}
                            />
                        </div>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label='Manufacturer Name * '
                                placeholder='Manufacturer Name * '
                                name='name'
                                value={formValue.name}
                                disabled={isOpen?.isDetails ? true : false}
                                focus={!!(typeof formError === "object" && formError?.name)}
                                error={!!(typeof formError === "object") ? formError?.name : ""}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                            />
                        </div>
                    </div>
                </div>
            </CommonModal>
            {/* <div className='offBack_drop'></div> */}

            {/* Add New Category */}
            {showAddPartsCategory && <AddPartsCategory {...addPartsCategoryModalProps} />}

        </div>
    )
}

export default AddEditManufacturerModel